import * as CdsIcons from '@central-design-system/icons';

import { propsFactory } from '@components/utils';

import type { PropType } from 'vue';

export const makeExpandablePanelTitleProps = propsFactory(
  {
    /**
     * Иконка раскрытия
     */
    expandIcon: {
      type: String as PropType<CdsIcons.TCdsIconsName>,
      default: 'chevron-down',
      validator: (value: CdsIcons.TCdsIconsName) => CdsIcons.allowedIcons.includes(value)
    },
    /**
     * Иконка закрытия
     */
    collapseIcon: {
      type: String as PropType<CdsIcons.TCdsIconsName>,
      default: 'chevron-up',
      validator: (value: CdsIcons.TCdsIconsName) => CdsIcons.allowedIcons.includes(value)
    },
    /**
     * Скрыть иконку раскрытия/закрытия
     */
    hideActions: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'CdsExpandablePanelTitle'
);
